import { Controller } from '@hotwired/stimulus';
import { patch } from '@rails/request.js';
import 'cropperjs';
import CropHelper from './helpers/crop';
import ProfileUploadBaseController from './profile_upload_base_controller';
// Profile Photo Update Controller
export default class extends ProfileUploadBaseController {
  static targets = ['input', 'preview', 'cameraIcon', 'spinnerIcon'];

  connect() {
    this.setupFileInput();
    this.initCropHelper();
  }

  setupFileInput() {
    // Add event listener for file selection
    this.inputTarget.addEventListener(
      'change',
      this.handleFileSelect.bind(this)
    );
  }

  initCropHelper() {
    // Initialize the crop helper with our configuration
    // Profile picture is square (400x400px)
    this.cropHelper = new CropHelper({
      maxSize: 400, // Width and height (square)
      aspectRatio: 1, // Square aspect ratio
      previewElement: this.hasPreviewTarget
        ? this.previewTarget
        : document.getElementById('profile-image-preview'),
      onCropComplete: this.postToAPI.bind(this),
    });
  }

  handleFileSelect(event) {
    const file = event.target.files[0];
    if (!file) return;

    // Check if file is an image
    if (!file.type.match('image.*')) {
      alert('Please select an image file');
      this.resetFileInput(); // Also reset if the file is not an image
      return;
    }

    // Create a FileReader to read the image
    const reader = new FileReader();
    reader.onload = (e) => {
      this.cropHelper.showCropModal(e.target.result);
    };
    reader.readAsDataURL(file);

    // Reset the input immediately after starting the read
    // This ensures the change event will fire next time, even with the same file
    this.resetFileInput();
  }

  // Reset the file input so the same file can be selected again
  resetFileInput() {
    if (this.inputTarget) {
      this.inputTarget.value = '';
    }
  }

  postToAPI(blob) {
    // Create a FormData object to send the image to the server
    const formData = new FormData();
    formData.append('user[profile_picture]', blob, 'profile_picture.png');

    this.spinnerIconTarget.classList.remove('hidden');
    this.cameraIconTarget.classList.add('hidden');

    // Use Rails request.js to send the image to the server
    patch('/profile/update_picture', {
      body: formData,
      responseKind: 'json',
    })
      .then((response) => {
        if (response.ok) {
          return response.json;
        }
      })
      .then((data) => {
        // Success handling
      })
      .catch((error) => {
        console.error('Error updating profile picture:', error);
      });
  }

  disconnect() {
    // Clean up when controller is disconnected
    if (this.cropHelper) {
      this.cropHelper.destroy();
      this.cropHelper = null;
    }

    // Remove event listeners
    if (this.inputTarget) {
      this.inputTarget.removeEventListener('change', this.handleFileSelect);
    }
  }
}
